var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.printerCls,
    style: (_vm.paperType)
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "100%",
      "height": "100%",
      "padding": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "textAlign": "center",
      "paddingBottom": "5px",
      "marginTop": "9px"
    },
    style: ({
      marginRight: _vm.showBarcode ? '60px' : ''
    })
  }, [_c('span', {
    style: ({
      borderBottom: '1px solid #000',
      fontSize: '16px',
      padding: _vm.thin ? '0' : '3px 6px',
      lineHeight: _vm.thin ? 1 : 1.5
    })
  }, [_vm._v(_vm._s(_vm.showChainName ? _vm.chainName : '') + " " + _vm._s(_vm.layout.danjuleixing))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBarcode),
      expression: "showBarcode"
    }],
    staticClass: "barcode-container",
    staticStyle: {
      "position": "absolute",
      "top": "-25px",
      "right": "-0px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.drawBarcode()
    }
  })]), _vm._v(" "), (_vm.page === 1 || (_vm.page > 1 && _vm.layout.yetoudayin === '每页打印')) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, _vm._l((_vm.headItems), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        'print-addr': item.key && _vm.alones.includes(item.key),
        'print-ellipsis': true
      },
      style: ({
        float: 'left',
        width: _vm.alones.includes(item.key) ? '100%' : '33.33%',
        height: _vm.thin ? _vm.height.thin : _vm.height.base,
        lineHeight: _vm.thin ? _vm.height.thin : _vm.height.base,
        fontSize: _vm.layout.zitidaxiao || '12px'
      })
    }, [_vm._v("\n                    " + _vm._s(_vm.tempFmt(item, item.key)) + "\n                ")])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    class: [{
      'table-empty': _vm.printData.length === 0,
      'table-thin': _vm.thin
    }, 'table-' + _vm.layout.zitidaxiao || '12px'],
    staticStyle: {
      "clear": "both",
      "padding": "3px 0"
    }
  }, [_c('vxe-table', {
    ref: "table",
    attrs: {
      "border": 'none',
      "column-config": {
        resizable: true
      },
      "resizable-config": {
        minWidth: _vm.getMinWidth
      },
      "data": _vm.printData,
      "header-cell-style": _vm.cellStyle,
      "cell-style": _vm.cellStyle
    },
    on: {
      "resizable-change": _vm.changeWidth
    }
  }, _vm._l((_vm.printColumns), function(item, idx) {
    return _c('vxe-column', {
      key: idx,
      attrs: {
        "field": item.field,
        "title": item.title,
        "width": item.width
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.page === _vm.pages || (_vm.page !== _vm.pages && _vm.layout.yeweidayin === '每页打印')) ? _c('div', _vm._l((_vm.footItems), function(item, index) {
    return _c('div', {
      key: index,
      class: {
        'print-addr': item.key && _vm.alones.includes(item.key),
        'print-ellipsis': true
      },
      style: ({
        float: 'left',
        height: _vm.thin ? _vm.height.thin : _vm.height.base,
        lineHeight: _vm.thin ? _vm.height.thin : _vm.height.base,
        width: _vm.alones.includes(item.key) ? '100%' : '33.33%',
        fontSize: _vm.layout.zitidaxiao || '12px'
      })
    }, [_vm._v("\n                    " + _vm._s(_vm.tempFmt(item, item.key)) + "\n                ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.layout.dayinyema === 'true' || _vm.layout.dayinyema === true) ? _c('div', {
    style: ({
      position: 'absolute',
      bottom: 0,
      right: 0,
      fontSize: _vm.layout.zitidaxiao || '12px'
    })
  }, [_vm._v("第" + _vm._s(_vm.page || 1) + "页/共" + _vm._s(_vm.pages || 1) + "页")]) : _vm._e()])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260ce524","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/web/xtsz/dymbsz/mblb/PrintForm.vue
// module id = U0h6
// module chunks = 138